import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { Fade } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faPhone } from '@fortawesome/free-solid-svg-icons'
import Button from './Utils/Button'
import '../styles/Nav.css'
import '../styles/NavBurger.css'
import logo from '../assets/logo.jpg'
import { BrowserView, MobileView } from 'react-device-detect'

function Nav() {

    const navigate = useNavigate()
    const location = useLocation()
    const [menuDisplayMobile, setMenuDisplayMobile] = useState(false)
    const [menuDisplayMobileSublink, setMenuDisplayMobileSublink] = useState(false)
    const [navBurgerColor, setNavBurgerColor] = useState(null)

    const navLinks = [
        {
            name: 'Accueil',
            link: '/'
        }, {
            name: 'Diagnostics',
            link: '/diagnostic',
            sublinks: [
                {
                    name: 'Vente',
                    link: '/vente',
                    sublinks2: [
                        {
                            name: 'Loi Carrez',
                            link: '/loi-Carrez',
                        }, {
                            name: 'Diagnostic DPE',
                            link: '/diagnostic-DPE',
                        }, {
                            name: 'Diagnostic électricité',
                            link: '/diagnostic-électricité',
                        }, {
                            name: 'Diagnostic gaz',
                            link: '/diagnostic-gaz',
                        }, {
                            name: 'Diagnostic plomb',
                            link: '/diagnostic-plomb',
                        }, {
                            name: 'Diagnostic amiante',
                            link: '/diagnostic-amiante',
                        }, {
                            name: 'Diagnostic termites',
                            link: '/diagnostic-termite',
                        }, {
                            name: 'Audit énergétique',
                            link: '/audit-énergétique',
                        }, {
                            name: 'Diagnostic ERP',
                            link: '/diagnostic-ERP',
                        }
                    ]
                }, {
                    name: 'Location',
                    link: '/location',
                    sublinks2: [
                        {
                            name: 'Loi Boutin',
                            link: '/loi-Boutin',
                        }, {
                            name: 'Diagnostic DPE',
                            link: '/diagnostic-DPE',
                        }, {
                            name: 'Diagnostic électricité',
                            link: '/diagnostic-électricité',
                        }, {
                            name: 'Diagnostic gaz',
                            link: '/diagnostic-gaz',
                        }, {
                            name: 'Diagnostic plomb',
                            link: '/diagnostic-plomb',
                        }, {
                            name: 'Diagnostic amiante',
                            link: '/diagnostic-amiante',
                        }, {
                            name: 'Diagnostic ERP',
                            link: '/diagnostic-ERP',
                        }
                    ]
                }
            ]
        }, {
            name: 'Expertises',
            link: '/expertises',
            sublinks: [
                {
                    name: 'Diagnostic amiante avant travaux',
                    link: '/diagnostic-amiante-avant-travaux',
                }, {
                    name: 'Diagnostic DPE avec mention',
                    link: '/diagnostic-DPE-avec-mentions',
                }, {
                    name: 'Diagnostic DPE conseil',
                    link: '/diagnostic-DPE-conseil',
                }, {
                    name: 'Diagnostic accessibilité',
                    link: '/diagnostic-accessibilité-handicapé',
                }, {
                    name: 'Audit énergétique consultatif',
                    link: '/audit-énergétique-consultatif',
                }, {
                    name: 'Plans cotés 2D',
                    link: '/plans-cotés-2D',
                }, {
                    name: 'Mise en élévation des plans en 3D',
                    link: '/plans-élévation-3D',
                }
            ]
        }, {
            name: 'Contact',
            link: '/contact'
        }
    ]

    useEffect(() => {

        getNavBurgerColors()

    }, [])

    function getNavBurgerColors() {

        const navBurgerColor = getComputedStyle(document.body).getPropertyValue('--navBurgerActive')
        setNavBurgerColor(navBurgerColor)

    }

    function displaySublink(type, idElement) {

        const link = document.getElementById(idElement)
        const sublink = link.querySelector('.navCenterSublinkContainer')
        const sublinkIcon = link.querySelector('.navCenterSublinkIcon')
        if (type === 'display') {
            sublink.style.height = (sublink.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else if (type === 'hide') {
            sublink.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function displaySublink2(idElement, idSubElement) {

        const sublinkContainer = document.getElementById(idElement).querySelector('.navCenterSublinkContainer')
        const sublink = document.getElementById(idSubElement)
        const sublink2 = sublink.querySelector('.navCenterSublink2Container')
        const sublinkIcon = sublink.querySelector('.navCenterSublinkIcon')
        if (sublink2.style.height === '0px' || !sublink2.style.height) {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight + sublink2.scrollHeight) + 'px'
            sublink2.style.height = (sublink2.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight - sublink2.scrollHeight) + 'px'
            sublink2.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function displayLinkBurger() {

        var navMobile = document.getElementById("navMobileLink")
        var nav = document.getElementById("nav")
        if (!menuDisplayMobile) {
            setMenuDisplayMobile(true)
            navMobile.style.height = (navMobile.scrollHeight) + 50 + 'px'
            navMobile.style.padding = "30px 0 30px 0"
            nav.style.background = getComputedStyle(document.body).getPropertyValue('--navBurger')
        } else {
            window.scrollTo({ top: 0, behavior: 'instant' })
            setMenuDisplayMobile(false)
            navMobile.style.height = "0"
            navMobile.style.padding = "0"
            nav.style.background = getComputedStyle(document.body).getPropertyValue('--nav')
        }

    }

    function displaySublinkBurger(idElement) {

        const navMobile = document.getElementById("navMobileLink")
        const link = document.getElementById(idElement)
        const sublink = link.querySelector('.navCenterSublinkContainerMobile')
        const sublinkIcon = link.parentElement.querySelector('.navCenterLinkIconMobile')
        if (!menuDisplayMobileSublink) {
            setMenuDisplayMobileSublink(true)
            navMobile.style.height = 'auto'
            sublink.style.height = (sublink.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else {
            setMenuDisplayMobileSublink(false)
            sublink.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function displaySublink2Burger(idElement, idSubElement) {

        const sublinkContainer = document.getElementById(idElement).querySelector('.navCenterSublinkContainerMobile')
        const sublink = document.getElementById(idSubElement)
        const sublink2 = sublink.querySelector('.navCenterSublink2ContainerMobile')
        const sublinkIcon = sublink.querySelector('.navCenterSublinkIconMobile')
        if (sublink2.style.height === '0px' || !sublink2.style.height) {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight + sublink2.scrollHeight) + 'px'
            sublink2.style.height = (sublink2.scrollHeight) + 'px'
            sublinkIcon.style.transform = 'rotate(-90deg)'
        } else {
            sublinkContainer.style.height = (sublinkContainer.scrollHeight - sublink2.scrollHeight) + 'px'
            sublink2.style.height = '0'
            sublinkIcon.style.transform = 'rotate(0deg)'
        }

    }

    function hideLinkBurger() {

        window.scrollTo({ top: 0, behavior: 'instant' })
        const sublink2 = document.getElementsByClassName('navCenterSublink2ContainerMobile')
        for (let i = 0; i < sublink2.length; i++) {
            sublink2[i].style.height = '0'
        }
        const sublink = document.getElementsByClassName('navCenterSublinkContainerMobile')
        for (let i = 0; i < sublink.length; i++) {
            sublink[i].style.height = '0'
        }
        setMenuDisplayMobileSublink(false)
        const sublinkIcon = document.getElementsByClassName('navCenterSublinkIconMobile')
        for (let i = 0; i < sublinkIcon.length; i++) {
            sublinkIcon[i].style.transform = 'rotate(0deg)'
        }
        const linkIcon = document.getElementsByClassName('navCenterLinkIconMobile')
        for (let i = 0; i < linkIcon.length; i++) {
            linkIcon[i].style.transform = 'rotate(0deg)'
        }
        const navMobile = document.getElementById("navMobileLink")
        const nav = document.getElementById("nav")
        setMenuDisplayMobile(false)
        navMobile.style.height = "0"
        navMobile.style.padding = "0"
        nav.style.background = getComputedStyle(document.body).getPropertyValue('--nav')

    }

    return (

        <nav>
            <div id='nav'>
                <BrowserView>
                    <Fade direction={'down'} duration={500}>
                        <Row>
                            <Col id='navLeft' sm={3}>
                                <Fade direction={'left'} duration={500}>
                                    <img src={logo} id='navLogo' alt='logo' onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/') }} />
                                </Fade>
                            </Col>
                            <Col id='navCenter' sm={6}>
                                {navLinks.map((item, index) => (
                                    <div
                                        key={index}
                                        id={item.link}
                                        className={location.pathname === item.link ? 'navCenterLinkActive' : 'navCenterLink'}
                                        onMouseEnter={() => item.sublinks ? displaySublink('display', item.link) : null}
                                        onMouseLeave={() => item.sublinks ? displaySublink('hide', item.link) : null}>
                                        <Link to={!item.sublinks ? item.link : null} onClick={() => !item.sublinks ? window.scrollTo({ top: 0, behavior: 'instant' }) : null}>{item.name}</Link>
                                        {item.sublinks ?
                                            <>
                                                <FontAwesomeIcon icon={faCaretLeft} className='navCenterSublinkIcon' />
                                                <div className='navCenterSublinkContainer'>
                                                    {item.sublinks.map((itemSublink, indexSublink) => (
                                                        <div
                                                            key={indexSublink}
                                                            id={itemSublink.link}
                                                            className='navCenterSublink'
                                                            onClick={(e) => {
                                                                if (itemSublink.sublinks2) {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    displaySublink2(item.link, itemSublink.link)
                                                                }
                                                            }}>
                                                            <Link to={!itemSublink.sublinks2 ? itemSublink.link : null} onClick={() => !itemSublink.sublinks2 ? window.scrollTo({ top: 0, behavior: 'instant' }) : null}>{itemSublink.name}</Link>
                                                            {itemSublink.sublinks2 ?
                                                                <>
                                                                    <FontAwesomeIcon icon={faCaretLeft} className='navCenterSublinkIcon' />
                                                                    <div className='navCenterSublink2Container'>
                                                                        {itemSublink.sublinks2.map((itemSublink2, indexSublink2) => (
                                                                            <div key={indexSublink2} className='navCenterSublink2'>
                                                                                <Link to={itemSublink2.link} onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}>{itemSublink2.name}</Link>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                                : null
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                            : null
                                        }
                                    </div>
                                ))}
                            </Col>
                            <Col id='navRight' sm={3}>
                                <Fade direction={'right'} duration={500}>
                                    <Link to="tel:0658802134">
                                        <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={"06 58 80 21 34"} />
                                    </Link>
                                </Fade>
                            </Col>
                        </Row>
                    </Fade>
                </BrowserView>

                <MobileView>
                    <div id="navMobileBurger">
                        <Fade direction={'left'} duration={500}>
                            <img src={logo} id='navLogoMobile' alt='logo' onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/') }} />
                        </Fade>
                        <div className={menuDisplayMobile ? "navMobileBurglar is-open" : "navMobileBurglar is-closed"} onClick={() => displayLinkBurger()}>
                            <div className="navMobileBurgerIcon">
                                <div className="navMobileBurgerIconContainer">
                                    <span className="navMobileBurgerBunTop"></span>
                                    <span className="navMobileBurgerFilling"></span>
                                    <span className="navMobileBurgerBunBot"></span>
                                </div>
                            </div>
                            <div className="burger-ring">
                                <svg className="svg-ring">
                                    <path className="path" fill="none" stroke={navBurgerColor} strokeMiterlimit="10" strokeWidth="4" d="M 34 2 C 16.3 2 2 16.3 2 34 s 14.3 32 32 32 s 32 -14.3 32 -32 S 51.7 2 34 2" />
                                </svg>
                            </div>
                            <svg width="0" height="0">
                                <mask id="mask">
                                    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke={navBurgerColor} strokeMiterlimit="10" strokeWidth="4" d="M 34 2 c 11.6 0 21.8 6.2 27.4 15.5 c 2.9 4.8 5 16.5 -9.4 16.5 h -4" />
                                </mask>
                            </svg>
                            <div className="path-burger">
                                <div className="animate-path">
                                    <div className="path-rotation"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='navMobileLink'>
                        {navLinks.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className='navMobileLinkText'>
                                        <Link
                                            to={!item.sublinks ? item.link : null}
                                            onClick={() => !item.sublinks ? hideLinkBurger() : displaySublinkBurger(item.link)}>
                                            {item.name}
                                            {item.sublinks ?
                                                <FontAwesomeIcon icon={faCaretLeft} className='navCenterLinkIconMobile' />
                                                : null
                                            }
                                        </Link>
                                        <div id={item.link}>
                                            {item.sublinks ?
                                                <>
                                                    <div className='navCenterSublinkContainerMobile'>
                                                        {item.sublinks.map((itemSublink, indexSublink) => (
                                                            <div key={indexSublink}>
                                                                <div id={itemSublink.link} className='navMobileSublink'>
                                                                    <Link
                                                                        to={!itemSublink.sublinks2 ? itemSublink.link : null}
                                                                        onClick={() => !itemSublink.sublinks2 ? hideLinkBurger() : displaySublink2Burger(item.link, itemSublink.link)}>
                                                                        {itemSublink.name}
                                                                    </Link>
                                                                    {itemSublink.sublinks2 ?
                                                                        <>
                                                                            <FontAwesomeIcon icon={faCaretLeft} className='navCenterSublinkIconMobile' />
                                                                            <div className='navCenterSublink2ContainerMobile'>
                                                                                {itemSublink.sublinks2.map((itemSublink2, indexSublink2) => (

                                                                                    <div key={indexSublink2} className='navCenterSublink2'>
                                                                                        <Link to={itemSublink2.link} onClick={() => hideLinkBurger()}>{itemSublink2.name}</Link>
                                                                                    </div>

                                                                                ))}
                                                                            </div>
                                                                        </>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </MobileView>
            </div>
        </nav>

    )

}

export default Nav